<script>
    import {VueperSlide, VueperSlides} from 'vueperslides';
    import Modal from './Modal';

    export default {
        name: 'VueCarousel',

        components: {
            Modal,
            VueperSlides,
            VueperSlide,
        },

        data() {
            return {
                slideComponent: VueperSlide,
                ready: true,
            };
        },

        created() {
            this.$on('open', this.open);
        },

        methods: {
            open(index = 0) {
                this.ready = false;
                this.$refs.modal.$emit('open');

                this.$nextTick(() => {
                    this.$refs.slides.goToSlide(index);
                    this.ready = true;
                });
            },
        },
    };
</script>

<template>
    <Modal ref="modal">
        <template #title>
            <slot name="title"/>
        </template>

        <template #default>
            <VueperSlides ref="slides"
                          v-show="ready"
                          fade
                          fractions
                          progress
                          slide-multiple
                          fixed-height="500px"
                          :dragging-distance="200">
                <slot name="items" :slide="slideComponent"/>
            </VueperSlides>
        </template>
    </Modal>
</template>